module.exports = ["XS", "S", "M", "L", "XL", "XXL"];



// WEBPACK FOOTER //
// ./src/data/clothingSizes.js